import { Dispatch, SetStateAction } from 'react'
import Typography from '@mui/material/Typography'
import CrossIcon from '../../images/crossIcon.svg'
import { Box, Button, Dialog, IconButton, useMediaQuery } from '@mui/material'
import { appTheme } from '../../theme'

const HorizontalLine = () => {
  return (
    <Box
      sx={{
        width: '100%',
        border: '0.5px solid #C9C5CA'
      }}
    ></Box>
  )
}

const Slots = (props: {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  selectedSlot: string
  availableSlots: string[]
  setSlot: any
}) => {
  const fullScreen = useMediaQuery(appTheme.breakpoints.down('md'))

  const selectSlot = (event: any) => {
    props.setSlot(event.target.value)
  }

  return (
    <Box>
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        onClose={() => props.setOpen(false)}
        PaperProps={{
          style: {
            borderRadius: '12px',
            width: '276px',
            height: '390px',
            background: '#FFFFFF'
          }
        }}
      >
        <Box
          sx={{
            px: '16px',
            py: '12px',
            gap: '8px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                ml: '24px'
              }}
            >
              <Typography fontSize='18px' fontWeight='600' color='#000000'>
                {props.selectedSlot}
              </Typography>
              <Typography display='inline' noWrap>
                &nbsp;
              </Typography>
              <Typography
                fontSize='18px'
                fontWeight='600'
                color='#000000'
                sx={{ opacity: '0.5' }}
              >
                {' '}
                ET
              </Typography>
            </Box>
            <IconButton onClick={() => props.setOpen(false)} size="large">
              <Box
                sx={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  backgroundColor: '#F0F0F0',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Box component='img' src={CrossIcon} alt='Cross Icon' />
              </Box>
            </IconButton>
          </Box>
          <HorizontalLine />

          <Box
            sx={{
              maxHeight: '305px',
              overflowX: 'hidden',
              overflowY: 'scroll'
            }}
          >
            {props.availableSlots.map((slot: string) => (
              <Button
                fullWidth={true}
                style={{ justifyContent: 'flex-start' }}
                sx={{
                  width: '244px',
                  background:
                    slot === props.selectedSlot ? '#F0F0F0' : 'transparent',
                  borderRadius: '4px',
                  mt: '4px',
                  fontSize: '14px',
                  pl: '24px',
                  color: '#565656'
                }}
                value={slot}
                onClick={selectSlot}
              >
                {slot}
              </Button>
            ))}

            {props.availableSlots.length === 0 && (
              <Typography sx={{ mt: 5, textAlign: 'center' }}>
                No slots available
              </Typography>
            )}
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}

export default Slots
